module.exports = __webpack_public_path__ + "static/media/bisnode-logo.00416ebd.svg";